const debug = false
// const debug = "groupByOperator"

export default function groupByOperator(items:any[], groupByField:any, groupBySortDirection:any, fieldsManager:any) {
    debug && console.log(debug, 'process', items, groupByField, groupBySortDirection, fieldsManager)

    const Field = groupByField ? fieldsManager.get(groupByField) : null;

    const result = _(items)
        .groupBy(model=>{
            if (!groupByField) return null;
            // this is done to prevent difference between null and undefined !
            const groupByValue = Field ? Field.groupValue(model[groupByField]) : model[groupByField];
            return !_.isNil(groupByValue) ? groupByValue : null;
        })
        .toPairs()
        .map(group=>({
            // groupByField:   groupByField, - vozmozno ponadibitsya ?
            groupByValue:   group[0],
            groupSortValue:  Field ? Field.groupSortValue(group[0]) : null,
            // groupByLabel:   Field ? Field.groupLabel(group[0]) : null,
            // groupByColor:   Field && Field.groupColor ? Field.groupColor(group[0]) : null,
            models:         group[1]
        }))
        .orderBy(group=>group.groupSortValue, groupBySortDirection)
        .value();

    return result
}
